import {
  Facebook,
  Instagram,
  Linkedin,
  Mail,
  Phone,
  MapPin,
  BadgeCheckIcon,
} from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";
import FeedbackModal from "../Components/Forms/FeedBackModal";

const Footer = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <footer className="footer-container-fb">
        <div className="footer-top-fb">
          {/* Branding */}
          <div className="footer-logo-fb">
            <h2>Westerns360</h2>
            <p>Your gateway to premium property investments and services.</p>
          </div>

          {/* Our Services */}
          <div className="footer-services-fb">
            <h4>Our Services</h4>
            <ul>
              <li>Sales Assistance</li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="footer-links-fb">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/">About</Link>
              </li>
              <li>
                <Link to="/">Projects</Link>
              </li>
              <li>
                <Link to="/">Services</Link>
              </li>
              <li onClick={() => setOpen(true)} style={{ cursor: "pointer" }}>
                Feedback
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact-fb">
            <h4>Contact Us</h4>
            <p>
              <Phone size={16} />+91 96190 33222
            </p>
            <p>
              <Mail size={16} />  info@westerns360.com
            </p>
            <p>
              <MapPin size={16} /> Shop No 15, Swapnpurti Chs Ltd, Thakur Village, Opposite Viceroy Savana, Kandivali East, Mumbai - 400101
            </p>
            {/* <p><BadgeCheckIcon size={16} /> RERA: A51800044399</p> */}
          </div>
        </div>

        {/* Footer Bottom */}
        {/* <div className="footer-bottom-fb">
          <p style={"align:left"}>Policy | Terms & Conditions</p>
          <p>&copy; {new Date().getFullYear()}, <a href="https://100billiontech.com/ownership" target="_blank"
            rel="noreferrer">Copy-rights reserved</a>. </p>
        </div> */}
        <div
          className="footer-bottom-fb"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <p>MAHARERA No: A041332504039  | <a href="/">Policy</a> | <a href="/">Terms & Conditions</a></p>
<p>
            &copy; {new Date().getFullYear()},{" "}
            Copy-rights reserved | Designed By: <a
              href="https://100billiontech.com/"
              target="_blank"
              rel="noreferrer"
            >100billion Tech</a>
          </p>
        </div>
      </footer>

      <FeedbackModal isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default Footer;
